import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {QuotesModel} from '../../models/quotes.model';
import {MyProjectTabIdEnum} from '../../enums/my-project-tab-id.enum';
import {MyQuotesDialogModeEnum} from '../../enums/my-quotes-dialog-mode.enum';
import {EnumUtils} from '../../utils/enum.utils';
import {ProjectsBodyScrollingService} from '../../services/projects-body-scrolling.service';
import {UtilityService} from '../../../../shared/services/utility.service';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';


@Component({
    selector: 'app-quotes-modal',
    templateUrl: './quotes-modal.component.html',
    styleUrls: ['./quotes-modal.component.scss']
})
export class QuotesModalComponent extends ModalDialogV3 implements OnInit {

    public quotes: QuotesModel;
    public isInitialized = false;
    public myProjectTabIdEnum = MyProjectTabIdEnum;

    public quoteHardwareUrl: any;
    public quoteSupplyUrl: any;

    // private parentEditDialog: ModalDialog;

    private activeTabId = MyProjectTabIdEnum.HARDWARE;

    public activeDialogMode = MyQuotesDialogModeEnum.BOTH;  // this is only mode which should be used by new spec

    @ViewChild('hardwareIframe', {static: true, read: ElementRef}) hardwareIframe: ElementRef;
    @ViewChild('supplyIframe', {static: true, read: ElementRef}) supplyIframe: ElementRef;


    constructor(private utilityService: UtilityService) {
        super();
    }

    ngOnInit() {
        this.quotes = (this.modalParams.model as { quotes: QuotesModel, dialogMode: MyQuotesDialogModeEnum }).quotes;
        this.activeDialogMode = (this.modalParams.model as { quotes: QuotesModel, dialogMode: MyQuotesDialogModeEnum }).dialogMode;
        this.activeDialogMode = this.activeDialogMode === undefined ? MyQuotesDialogModeEnum.BOTH : (this.activeDialogMode as MyQuotesDialogModeEnum);
        // this.activeDialogMode = MyQuotesDialogModeEnum.HARDWARE_ONLY as MyQuotesDialogModeEnum;

        this.activeTabId = this.activeDialogMode === MyQuotesDialogModeEnum.SUPPLY_ONLY ? MyProjectTabIdEnum.SUPPLY : MyProjectTabIdEnum.HARDWARE;

        if (!this.quotes.quoteHardware && !this.quotes.quoteSupply) {
            console.warn('quote dialog was skipped because  no one quotes pdf-s was provided');
            this.close();
        }

        if (this.quotes.quoteHardware) {
            const blob = new Blob([this.utilityService.b64toBlob(this.quotes.quoteHardware)], {type: 'application/pdf'});
            this.quoteHardwareUrl = window.URL.createObjectURL(blob);
            this.hardwareIframe.nativeElement.src = this.quoteHardwareUrl + '#toolbar=0';
        }


        if (this.quotes.quoteSupply) {
            const blob = new Blob([this.utilityService.b64toBlob(this.quotes.quoteSupply)], {type: 'application/pdf'});
            this.quoteSupplyUrl = window.URL.createObjectURL(blob);
            this.supplyIframe.nativeElement.src = this.quoteSupplyUrl + '#toolbar=0';

            if (!this.quotes.quoteHardware && this.activeDialogMode !== MyQuotesDialogModeEnum.HARDWARE_ONLY) {
                this.activeTabId = MyProjectTabIdEnum.SUPPLY;
            }
        }


    }

    onModalClicked() {

    }

    onCancelBtnClicked() {
        this.close();
    }

    onTabBtnClicked(tabId: MyProjectTabIdEnum) {

        if (tabId === MyProjectTabIdEnum.HARDWARE && this.quoteHardwareUrl) {
            this.activeTabId = tabId;
        }

        if (tabId === MyProjectTabIdEnum.SUPPLY && this.quoteSupplyUrl) {
            this.activeTabId = tabId;
        }
    }


    public onSubmitBtnClicked() {
        this.announceModelChanged({msg: 'please close dialog'});
        this.close();
    }

    public isTabActive(tabId: MyProjectTabIdEnum): boolean {
        return tabId === this.activeTabId;
    }

    public isVisibleInActiveMode(tabId: MyProjectTabIdEnum): boolean {
        return this.activeDialogMode === MyQuotesDialogModeEnum.BOTH || this.activeDialogMode === MyQuotesDialogModeEnum [EnumUtils.getKeyByValue(MyProjectTabIdEnum, tabId) + '_ONLY'];
    }

    public getBottomBtnTitle() {
        // return this.activeDialogMode === MyQuotesDialogModeEnum.BOTH ? 'Angebot absenden' : 'Schließen';
        return 'Schließen';
    }

    public onDownloadBtnClicked() {

        if (this.quotes) {
            const blob = this.activeTabId === MyProjectTabIdEnum.HARDWARE ? this.utilityService.b64toBlob(this.quotes.quoteHardware) : this.utilityService.b64toBlob(this.quotes.quoteSupply);
            if (blob) {
                const data = window.URL.createObjectURL(blob);
                //
                const link = document.createElement('a');
                link.href = data;
                link.download = this.activeTabId === MyProjectTabIdEnum.HARDWARE ? this.quotes.quoteHardwareFilename : this.quotes.quoteSupplyFilename;

                if (!link.download) {
                    link.download = 'quote.pdf';
                }
                if (link.download.slice(-4).toLowerCase() !== '.pdf') {
                    link.download += '.pdf';
                }

                // this is necessary as link.click() does not work on the latest firefox
                link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

                setTimeout(function () {
                    // For Firefox it is necessary to delay revoking the ObjectURL
                    window.URL.revokeObjectURL(data);
                }, 100);
                return;
            }
        } else {
            console.error('quote pdf file was not found');
        }

    }

    public close() {
        super.close();
    }
}
